import React, { useEffect, useState } from "react";
import "./Mobile-menu-modal.scss";
import envConfigs from "../../configs/envConfigs";
import { Link } from "react-router-dom";
import searchIcon from "../../assets/images/searchicon.svg";
import upIcon from "../../assets/images/chevronUpWhite.svg";
import closeIcon from "../../assets/images/closeWhite.svg";
import { useTranslation } from "react-i18next";


const MobileMenuModal = ({ menuResponse, setShowMobileMenu, oktaUrl, show }) => {
	const [prevVal, setPrevVal] = useState(null);
	const [visible, setVisible] = useState([
	]);
	const { t, i18n } = useTranslation(["labels"]);

	useEffect(() => {
		const menuList = menuResponse?.navigationmenu?.navigation;
		if (menuList) {
			setVisible(menuList.map((_item, index) => ({
				id: index,
				open: false
			})));
		}
	}, [menuResponse])

	const { bookingPortalAppUrl } = envConfigs;


	const getSubmenuEServices = ({ categories, navigationsubmenu }) => {
		return (
			<div className="sub-menu-expandable">
				{categories && categories.length ? (
					categories.map((category) => (
						<div className="submenu-row-section">
							<h3 className="submenu-title">
								{category.categorytitle}
							</h3>
							<ul className="submenu-list-group">
								{navigationsubmenu && navigationsubmenu.length ? (
									navigationsubmenu.map((submenu) => {
										return submenu.categorytype === category.categorykey ? (
											<li className="list-group-item">
												{(submenu.externalPortalLink &&
													submenu.externalPortalLink !== "") ||
													(submenu.redirecturl &&
														submenu.redirecturl.startsWith(
															bookingPortalAppUrl
														)) ? (
													<a
														href={
															submenu.externalPortalLink &&
																submenu.externalPortalLink !== ""
																? submenu.externalPortalLink.replace(
																	bookingPortalAppUrl,
																	""
																)
																: submenu.redirecturl.replace(
																	bookingPortalAppUrl,
																	""
																)
														}
														target={submenu.newwindow}
													>
														{submenu.title}
													</a>
												) : (
													<a
														href={
															oktaUrl
																? `${oktaUrl}?RelayState=${encodeURIComponent(
																	submenu.redirecturl
																)}`
																: submenu.redirecturl
														}
														target={submenu.newwindow}
													>
														{submenu.title}
													</a>
												)}
											</li>
										) : (
											<></>
										);
									})
								) : (
									<></>
								)}
							</ul>
						</div>
					))
				) : (
					<></>
				)}
			</div>

		);
	};

	const openSubMenu = (id) => {
		let checkMenu = visible.some((item) => item.id === id);
		if (checkMenu) {
			if (prevVal == id) {
				let newArr = [...visible];
				newArr[id].open = !newArr[id].open;
				setVisible(newArr);
			} else {
				visible.map((item) => (item.open = false));
				let newArr = [...visible];
				newArr[id].open = !newArr[id].open;
				setVisible(newArr);
			}
		} else {
			visible.map((item) => (item.open = false));
		}
		setPrevVal(id);
	};
	return (
		<div className={`mobile-header-dialog${show ? " show" : ""}`}>
			<div className="mobile-dialog-content">
				{menuResponse && menuResponse.mobileNavigation && (
					<div className="mobile-dialog-header">
						<a
							href={`${envConfigs.parentUrl}/${i18n.language}/eag/etihadairways/etihadcom/language-masters/${i18n.language}/search`}
							rel="noopener noreferrer"
						>
							<img src={searchIcon} />
						</a>
						<img
							src={closeIcon}
							alt={t("COMMON.NAV_MENU_CLOSE")}
							// alt={menuResponse.mobileNavigation.navigationmenucloseiconalttext}
							className="close-icon"
							onClick={() => {
								setShowMobileMenu(false);
							}}
						/>
					</div>
				)}
				<div className="mobile-dialog-body">
					{menuResponse.navigationmenu &&
						menuResponse.navigationmenu.navigation &&
						menuResponse.navigationmenu.navigation.length ? (
						menuResponse.navigationmenu.navigation.map((item, index) => (
							<div
								className="header-menu-row"
								key={index}
								onClick={() => {
									if (item.categories?.length > 0) { openSubMenu(index); }
								}}
							>
								<div className="main-row">
									<div className="menu-label" id={index}>
										{item.redirecturl &&
											item.redirecturl.startsWith(bookingPortalAppUrl) ? (
											<Link
												to={item.redirecturl.replace(bookingPortalAppUrl, "")}
												className="navigation-menu-header"
											>
												{item.title}
											</Link>
										) : (
											<a
												onClick={(e) => {
													e.stopPropagation();
												}}
												href={
													oktaUrl
														? `${oktaUrl}?RelayState=${encodeURIComponent(
															item.redirecturl
														)}`
														: item.redirecturl
												}
												target={item.newwindow}
												className="navigation-menu-header"
											>
												{item.title}
											</a>
										)}
									</div>

									{item.categories?.length > 0 && (
										<div className="menu-icon">
											<img
												src={upIcon}
												className={`menu-icon-img ${visible.find((v) => v.id === index)?.open
													? "up"
													: "down"
													}`}
												alt={
													visible.find((v) => v.id === index)?.open
														? t("COMMON.EXPAND_ICON")
														// menuResponse.mobileNavigation
														// 	.navigationexpandiconalttext
														: t("COMMON.NAVCOLLAPSEICONTXT")
													// : menuResponse.mobileNavigation
													// 	.navigationcollapseiconalttext
												}
											/>
										</div>
									)}
								</div>
								<div className={`mob-submenu ${visible.find((v) => v.id === index)?.open ? "open" : ""}`}>
									{getSubmenuEServices(item)}
								</div>
							</div>
						))
					) : (
						<></>
					)}
				</div>
			</div>
		</div>
	);
};

export default MobileMenuModal;
